<template>
    <simple-select-input
        v-model="option"
        :options="options"
        :placeholder="placeholder"
        :required="true"
        name="option"
        @input="optionSelected()"
        focus
    />
</template>
<script>
/**
 * Option types to display in the select.
 *
 * @todo move to a config system when it becomes clearer how that should work.
 * @type {String}
 */

export default {
    props: {
        options: {
            type: Array,
            required: true
        },
        currentOption: {
            // Do not convert null into a 0 (zero)
            type: [Number, String],
            default: null
        },
        placeholder: {
            type: String,
            default: null
        }
    },
    /**
     * Add all the properties found in the data object to Vue’s reactivity system.
     *
     * @return {object}
     */
    data() {
        return {
            option: null
        };
    },
    /**
     * Set initial data as soon as the component is ready.
     */
    mounted() {
        if (this.currentOption) {
            this.option = this.currentOption;

            return;
        }

        this.option = this.getDefaultOption();
    },
    methods: {
        /**
         * Get the default option to display in the select.
         *
         * @return {string|number}
         */
        getDefaultOption() {
            let options = this.options;

            if (options.length) {
                return options[0].key;
            }
        },
        /**
         * Fire an event with the selected option as payload.
         */
        optionSelected() {
            this.$emit('change', this.option);
        }
    }
};
</script>
